// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Doctor Who Universe - Aliens Configuration
 */

export const DoctorWhoAliensPlanets = {
  planets: {
    900: ['timelord', 'thedoctor'], // Gallifrey
    901: ['dalek'], // Skaro
    902: ['silence'], // Trenzalore
    903: ['cyberman'], // Mondas
    904: ['sontaran'], // Sontar
    905: ['vashtanerada'], // The Library
    906: ['ood'], // Ood Sphere
    907: ['slitheen'], // Raxacoricofallapatorius
    908: ['midnightentity'], // Midnight
    909: ['weepingangel'], // Medusa Cascade (rift)
    910: ['humannewearth', 'faceofboe'], // New Earth
    911: ['silence', 'weepingangel'] // Pandorica (prison)
  },
  randomEncounters: ['thedoctor', 'weepingangel', 'silence'],
  hostileSpecies: ['dalek', 'cyberman', 'weepingangel', 'vashtanerada'],
  friendlyTraders: ['ood', 'timelord']
};

export default DoctorWhoAliensPlanets;
